import BpkSmallChevronRight from '@skyscanner/backpack-web/bpk-component-icon/sm/chevron-right';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import RatingStatement from '../../HotelReviews/RatingStatement';

import ConfidentCardList from './ConfidentCardList';

import type { HotelReviewSummary } from '@shared/types/hotel-content';
import type { DomEvent } from '@shared/ui/common/RouteLink/RouteLink';

import STYLES from './RatingsContent.module.scss';

import ReviewRating, {
  SPACING_VARIANTS,
} from '@shared/ui/components/ReviewRating';

const cls = cssModules(STYLES);

type Props = {
  isMobile: boolean;
  onClick: DomEvent | (() => void);
  reviewSummary: HotelReviewSummary;
  confidentReview?: string;
};

const RatingsContent = ({
  confidentReview,
  isMobile,
  onClick,
  reviewSummary: {
    excellentSubratings,
    ratingProvider,
    reviewCount,
    score,
    scoreDescription,
    scoreImageUrl,
  },
}: Props) => {
  const reviewRatingComponent = (
    <ReviewRating
      score={score}
      count={reviewCount}
      image={scoreImageUrl}
      spacingVariant={isMobile ? undefined : SPACING_VARIANTS.FIT_CONTENT}
      large={!isMobile}
      scoreDescription={scoreDescription}
      hideTitle={isMobile}
    />
  );

  return (
    <div className={cls('RatingsContent')} data-test-id="reviews-ratings">
      <div className={cls('RatingsContent__wrap')}>
        {!isMobile && (
          <div className={cls('RatingsContent__ratingAndStatement')}>
            {reviewRatingComponent}
            <RatingStatement ratingProvider={ratingProvider} />
          </div>
        )}
        {isMobile && (
          <button
            type="button"
            className={cls('RatingsContent__reviewRatingButtonWrap')}
            onClick={onClick}
          >
            {reviewRatingComponent}
            <div className={cls('RatingsContent__chevronIcon')}>
              <BpkSmallChevronRight />
            </div>
          </button>
        )}
      </div>
      {excellentSubratings.length > 0 && (
        <button
          type="button"
          className={cls('RatingsContent__confidentsListButtonWrap')}
          onClick={onClick}
        >
          <ConfidentCardList
            confidentReview={confidentReview}
            excellentSubratings={excellentSubratings}
            isMobile={isMobile}
          />
        </button>
      )}
    </div>
  );
};

export default RatingsContent;
